import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./RemovePluginModal.module.css";
import ModalActionBar from "shared/ModalActionBar";
import { Modal } from "shared/Modal";
import CheckBoxItem from "../../../Shared/CheckBoxItem";

/**
 * Interactive component. Modal used to remove plugins
 */

export function RemovePluginModal({
  isOpen,
  onClose,
  onClick,
  doNotSync,
  withoutRefresh,
  pluginInfo,
  type,
}) {
  const [noRefresh, setNoRefresh] = useState(doNotSync);
  const [notSync, setNotSync] = useState(withoutRefresh);

  return (
    <div className={styles.container}>
      <Modal
        isOpen={isOpen}
        title={type}
        closeBtn="none"
        className={styles.modal}
      >
        <div className={styles.infoContainer}>
          <div className={styles.infoDiv}>
            <p className={styles.label}>Plugin ID:</p>
            <p className={styles.description}>{pluginInfo.id}</p>
          </div>
          <div className={styles.infoDiv}>
            <p className={styles.label}>IBO:</p>
            <p className={styles.description}>{pluginInfo.name}</p>
          </div>
          <div className={styles.infoDiv}>
            <p className={styles.label}>Plugged Into:</p>
            <p className={styles.description}>{pluginInfo.pluggedInto}</p>
          </div>
          <div className={styles.infoDiv}>
            <p className={styles.label}>Date Created:</p>
            <p className={styles.description}>
              {pluginInfo.date + " " + pluginInfo.time}
            </p>
          </div>

          <div className={styles.checkboxContainer}>
            <CheckBoxItem
              checked={notSync}
              name="Do not sync the user after removing the plugin if present"
              onClick={() => {
                setNotSync(!notSync);
              }}
            />
          </div>
          <div className={styles.checkboxContainer}>
            <CheckBoxItem
              checked={noRefresh}
              name="Sync without refreshing LOS information"
              onClick={() => {
                setNoRefresh(!noRefresh);
              }}
            />
          </div>
        </div>
        <div className={styles.btnContainer}>
          <ModalActionBar
            children={
              <div className={styles.btnDiv}>
                <button
                  type="button"
                  className={styles.cancelBtn}
                  onClick={onClose}
                >
                  CANCEL
                </button>
                <button
                  type="button"
                  className={styles.removeBtn}
                  onClick={onClick}
                >
                  REMOVE
                </button>
              </div>
            }
          />
        </div>
      </Modal>
    </div>
  );
}

RemovePluginModal.propTypes = {
  /**
   * Boolean to determine if modal is open
   */
  isOpen: PropTypes.bool,
  /**
   * Callback function for when the modal is closed.
   */
  onClose: PropTypes.func,
  /**
   * Function called when remove is clicked
   */
  onClick: PropTypes.func,
  /**
   * True if do not sync is checked
   */
  doNotSync: PropTypes.bool,
  /**
   * True if sync without refresh is checked
   */
  withoutRefresh: PropTypes.bool,
  /**
   * Object with the plugins info.
   */
  pluginInfo: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    pluggedInto: PropTypes.string,
    date: PropTypes.string,
    time: PropTypes.string,
  }),
  /**
   * Type of plugin (Group, LOS) to be displayed in the modal header.
   */
  type: PropTypes.string,
};
